import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Announcements from "./Announcements/Announcements.jsx";
import AddAnnouncementNew from "./Announcements/AddAnnouncementNew";
import EditAnnouncement from "./Announcements/EditAnnouncement";
import Settings from "./Settings/Settings";
import ChangePassword from "./Settings/ChangePassword";
import Reports from "./Reports/Reports";
import LiveCourses from "./LiveCourses/LiveCourses";
import CustomAddLiveCourse from "./LiveCourses/CustomAddLiveCourses";
import Login from "./Login/Login";
import NotFound from "./NotFound";
import WithLayout from "./RouterNavigation/WithLayout.jsx";
import CalendarSchedule from "./Calendar/CalendarSchedule.jsx";
import Schedule from "./Schedule/Schedule.jsx";
import ExamSchedule from "./Schedule/ExamSchedule.jsx";
import ViewSchedule from "./Schedule/ViewSchedule.jsx";

import ManageTutors from "./ManageTutors/ManageTutors.jsx";
import ManageStudents from "./ManageStudents/ManageStudents.jsx";
import Dashboard from "./Dashboard/index.jsx";
import StudentReports from "./Reports/StudentReports";
import TutorReports from "./Reports/Tutor/Reports";
import StudentExamScheduleStatistics from "./Reports/StudentExamScheduleStatistics";
import TutorExamScheduleStatistics from "./Reports/Tutor/TutorExamScheduleStatistics";
import AttendanceSchedule from "./Attendance/AttendanceSchedule";
import AttendanceReports from "./Reports/Attendance/Attendance";
import Feedback from './Feedback/Feedback';

export default function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Login />
        </Route>
         <Route exact path="/user-feedback">
          <Feedback />
        </Route>

     
        <PrivateRoute
          exact
          path="/dashboard"
          component={WithLayout(Dashboard)}
        />
        <PrivateRoute
          exact
          path="/add-live-courses"
          component={WithLayout(CustomAddLiveCourse)}
        />
        <PrivateRoute
          exact
          path="/announcements"
          component={WithLayout(Announcements)}
        />
        <PrivateRoute
          exact
          path="/add-announcement"
          component={WithLayout(AddAnnouncementNew)}
        />
        <PrivateRoute
          exact
          path="/edit-announcement/:announcementId"
          component={WithLayout(EditAnnouncement)}
        />
        <PrivateRoute exact path="/settings" component={WithLayout(Settings)} />
        <PrivateRoute
          exact
          path="/change-password"
          component={WithLayout(ChangePassword)}
        />
        <PrivateRoute
          exact
          path="/live-courses"
          component={WithLayout(LiveCourses)}
        />
        <PrivateRoute exact path="/reports" component={WithLayout(Reports)} />
         <PrivateRoute
          exact
          path="/reports/student/:studentId"
          component={WithLayout(StudentReports)}
        />
        <PrivateRoute
          exact
          path="/reports/tutor/:tutorId"
          component={WithLayout(TutorReports)}
        />
        <PrivateRoute
          exact
          path="/reports/student/examschedules/:studentId/:schedule"
          component={WithLayout(StudentExamScheduleStatistics)}
        />
        <PrivateRoute
          exact
          path="/reports/tutor/examschedules/:tutorId/:schedule"
          component={WithLayout(TutorExamScheduleStatistics)}
        />
        
        <PrivateRoute
          exact
          path="/calendar"
          component={WithLayout(CalendarSchedule)}
        />
        <PrivateRoute exact path="/schedule" component={WithLayout(Schedule)} />
        <PrivateRoute exact path="/exam-schedule" component={WithLayout(ExamSchedule)} />
        <PrivateRoute exact path="/view-schedule" component={WithLayout(ViewSchedule)} />
        <PrivateRoute
          exact
          path="/manage-tutors"
          component={WithLayout(ManageTutors)}
        />
        <PrivateRoute
          exact
          path="/manage-students"
          component={WithLayout(ManageStudents)}
        />
        <PrivateRoute
          exact
          path="/attendanceSchedule"
          component={WithLayout(AttendanceSchedule)}
        />
        <PrivateRoute
          exact
          path="/attendance-reports"
          component={WithLayout(AttendanceReports)}
        />

        <PrivateRoute path="*" component={WithLayout(NotFound)} />
      </Switch>
    </Router>
  );
}

function PrivateRoute({ children, component: Component, ...rest }) {

    return (
        <Route
            {...rest}
            render={(props) =>
                window.localStorage.getItem("user") ? (
                    <Component {...props}  />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/",
                            state: { from: props.location }
                        }}
                    />
                )
            }
        />
    );
}
